import { cva, cx } from '@vizit/theme';
import { WorkspaceSwitcher } from '../workspace-switcher';
import type { VerticalNavbarProps } from './types';
import { VerticalNavbarBanner } from './vertical-navbar-banner';
import { VerticalNavbarItem } from './vertical-navbar-item';
import { VerticalNavbarLogo } from './vertical-navbar-logo';
import { VerticalNavbarUserMenu } from './vertical-navbar-user-menu';

const styles = {
  nav: cva({
    base: ['flex flex-col items-center shrink-0', 'w-26 h-full', 'bg-primary border-r border-secondary', 'py-12 px-6'],
  }),
  section: cva({ base: 'flex flex-col items-center gap-16' }),
  itemList: cva({ base: 'flex flex-col items-center gap-1' }),
  spacer: cva({ base: 'flex-1' }),
  bottom: cva({ base: 'flex flex-col items-center gap-4' }),
};

function VerticalNavbar(props: VerticalNavbarProps) {
  const {
    items,
    menuItems,
    userEmail,
    avatarColor,
    appVersion,
    workspaceSwitcher,
    className,
    ref,
    'aria-label': ariaLabel = 'Main navigation',
  } = props;

  return (
    <nav ref={ref} className={cx(styles.nav(), className)} aria-label={ariaLabel}>
      <div className={styles.section()}>
        <VerticalNavbarLogo />

        <div className={styles.section()}>
          <ul className={styles.itemList()}>
            {items.map((item) => (
              <li key={item.key}>
                <VerticalNavbarItem
                  to={item.to}
                  label={item.label}
                  icon={item.icon}
                  isActive={item.isActive}
                  data-testid={`nav-${item.key}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={styles.spacer()} aria-hidden="true" />

      <div className={styles.bottom()}>
        {workspaceSwitcher && (
          <WorkspaceSwitcher model={workspaceSwitcher.model} onSelect={workspaceSwitcher.onSelect} />
        )}

        <VerticalNavbarUserMenu
          menuItems={menuItems}
          userEmail={userEmail}
          avatarColor={avatarColor}
          appVersion={appVersion}
        />
      </div>
    </nav>
  );
}

VerticalNavbar.Banner = VerticalNavbarBanner;
VerticalNavbar.Logo = VerticalNavbarLogo;
VerticalNavbar.Item = VerticalNavbarItem;
VerticalNavbar.UserMenu = VerticalNavbarUserMenu;

export { VerticalNavbar };
